export default "__VITE_ASSET__DDWDIOtX__"